export default class Dropdown {
	// markedClass = 'marked-dropdown'

	constructor(selector) {
		this.dropdowns = document.querySelectorAll(`${selector}`)
		this.init()
	}
	init() {
		this.dropdowns.forEach(item => {
			const [title, content, more] = item.children;

			title.addEventListener('click', () => {
				this.toggle(item, content);
				// item.classList.add(this.markedClass);
			})

		})
	}
	toggle(item) {
		if (item.classList.contains("active")) {
			item.classList.remove("active")
		} else {
			item.classList.add("active")
		}
	}
}



// WEBPACK FOOTER //
// ./src/js/new-design/dropdowns.js